<script>
    // type: 'paragraph'| 'title'
    export let type = "paragraph";
    export let animated = false;
    export let lineCount = 3;
    const cls = "sui-skt";
    let items = new Array(lineCount);
    $: {
        items = new Array(lineCount);
    }
</script>

{#if type === "paragraph"}
    <div class={cls}>
        {#each items as item, i}
            <div class:animated class={`${cls}-${type}`} />
        {/each}
    </div>
{:else}
    <div class:animated class={`${cls} ${cls}-title`} />
{/if}

<style lang="less">
    @import "./skeleton.less";
</style>
